import TooltipCreator from './tooltip-creator';

export default TooltipCreator;